// Route wrapper for the passport task.
//
// The actual implementation lives in tasks/passport/ to keep related files
// together while maintaining clear import paths.
//

import type { MetaFunction } from "react-router";

export function loader() {
  return null;
}

export const meta: MetaFunction = () => {
  return [
    { title: "Passport Photo Creator | privacy.photos" },
    {
      name: "description",
      content:
        "Create print-ready passport photos privately. All processing happens locally in your browser.",
    },
  ];
};

export { default } from "@/site/tasks/passport";
